export const isEmptyObj = (object): boolean => {
  if (Object.entries(object).length === 0) {
    return false
  }
  return true
}
